import useSession from '@/hooks/sessions/use-session';
import useFriendInfo from '@/hooks/users/use-friend-info';
import { useIsInternalUser } from '@/hooks/users/use-user-info';
import type { ConversationType } from '@/models/conversations/conversation-session';
import { UserType } from '@/models/user/user-info';

export default function useIsAdminSession(type: ConversationType, id: Nullable<number>): boolean {
  const { data: session } = useSession(type, id);
  const { data: friendInfo } = useFriendInfo(session?.UserID);
  const { isInternalUser } = useIsInternalUser();

  if (isInternalUser) return true;

  if (session?.SessionType === 'session' && friendInfo) {
    return friendInfo.FriendInfo.Type === UserType.Admin;
  }

  return false;
}
